import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { setLocale } from 'yup';
import translations from './i18n/translations';

export const supportedLngs = Object.keys(translations);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    resources: translations,
    fallbackLng: supportedLngs[0],
    nsSeparator: '.',
    debug: false,
    supportedLngs,
    cleanCode: true,
    interpolation: {
      escapeValue: false,
      formatSeparator: ',',
    },
  });

setLocale({
  mixed: {
    required: () => i18n.t('validations.required'),
    notType: ({ type }) => {
      switch (type) {
        case 'date':
          return i18n.t('validations.invalidDateMessage');
        case 'number':
          return i18n.t('validations.number');
        default:
          return 'Invalid type';
      }
    },
  },
  number: {
    integer: () => i18n.t('validations.integer'),
  },
  string: {
    max: ({ max }) => i18n.t('validations.maxLength', { length: max }),
    email: () => i18n.t('validations.email'),
  },
  array: {
    min: () => i18n.t('validations.required'),
  },
});
